import { format } from 'date-fns/format';
import { parse } from 'date-fns/parse';
import { startOfYear } from 'date-fns/startOfYear';
import { startOfWeek } from 'date-fns/startOfWeek';
import { startOfMonth } from 'date-fns/startOfMonth';
import { endOfWeek } from 'date-fns/endOfWeek';
import { endOfMonth } from 'date-fns/endOfMonth';
import { endOfYear } from 'date-fns/endOfYear';
import { addWeeks } from 'date-fns/addWeeks';
import { addMonths } from 'date-fns/addMonths';
import { addYears } from 'date-fns/addYears';
import { isWeekend } from 'date-fns/isWeekend';
import { isBefore } from 'date-fns/isBefore';
import { addDays } from 'date-fns/addDays';
import { addMinutes } from 'date-fns/addMinutes';
import { isSameMonth } from 'date-fns/isSameMonth';
import { lastDayOfMonth } from 'date-fns/lastDayOfMonth';
import { startOfDay } from 'date-fns/startOfDay';
import { isSameDay } from 'date-fns/isSameDay';
import { differenceInSeconds } from 'date-fns/differenceInSeconds';
import { formatISO } from 'date-fns/formatISO';
import { parseISO } from 'date-fns/parseISO';
import { isAfter } from 'date-fns/isAfter';
import { isValid } from 'date-fns/isValid';
import { isSameYear } from 'date-fns/isSameYear';


export {
  format,
  parse,
  startOfYear,
  startOfWeek,
  startOfMonth,
  endOfWeek,
  endOfMonth,
  endOfYear,
  addWeeks,
  addMonths,
  addYears,
  isWeekend,
  addDays,
  isSameMonth,
  lastDayOfMonth,
  startOfDay,
  isSameDay,
  differenceInSeconds,
  parseISO,
  isAfter,
  isValid,
  addMinutes,
  isBefore,
  isSameYear
};

export function formatISODate(date: number | Date) {
  return formatISO(date, { representation: 'date' });
}
